import { render, staticRenderFns } from "./SimuladorEmprestimo.vue?vue&type=template&id=8c96370c&"
import script from "./SimuladorEmprestimo.vue?vue&type=script&lang=js&"
export * from "./SimuladorEmprestimo.vue?vue&type=script&lang=js&"
import style0 from "./SimuladorEmprestimo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports